"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancellationPreferenceApi = void 0;
const handlers_1 = require("../handlers");
exports.cancellationPreferenceApi = (http, prefix = '/cancellation') => ({
    getById(id) {
        return http.get(`${prefix}/${id}`);
    },
    getByRecipient(recipient) {
        return http.get(`${prefix}/recipient/${recipient}`).catch(handlers_1._404({}));
    },
    getByCustomer(customer) {
        return http.get(`${prefix}/customer/${customer}`).catch(handlers_1._404({}));
    },
    updateByRecipient(recipient, cancellationPreference) {
        return http.post(`${prefix}/recipient/${recipient}`, cancellationPreference);
    }
});
//# sourceMappingURL=index.js.map